import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthExpiryInterceptor } from './app/Services/auth-expiry.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withHashLocation } from '@angular/router';
import { bootstrapApplication } from '@angular/platform-browser';
import { routes } from './app/app.routes';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AppComponent } from './app/app.component';
import { CallApi } from './app/Services/callApi';
import { ToolsBoxService } from './app/Services/tools.service';
import { AuthenticationService } from './app/Services/authentication.service';
import { UserService } from './app/Services/user.service';
import { ClientService } from './app/Services/client.service';


bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withHashLocation()),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        importProvidersFrom(FullCalendarModule),
        CallApi,
        ToolsBoxService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthExpiryInterceptor, multi: true },
        AuthenticationService,
        UserService,
        ClientService,
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: false } }, translation: { firstDayOfWeek: 1 } })
    ]
})
  .catch(err => console.error(err));
